"use client";
import React from "react";
import { motion, useInView } from "framer-motion";
import { useRef } from "react";
import Lottie from "lottie-react";

import gujarathMobile from "../../assets/animate/gujarat_map_mobile.json";

import gujarathWeb3 from "../../assets/animate/gujarat_map_web_3.json";
import { Box } from "@mui/material";
import { globalTransition } from "../../assets/animate/globalAnimation";

const ServicesSection: React.FC = () => {
  // Create refs for different sections to trigger animations
  const headerRef = useRef(null);
  const titleRef = useRef(null);
  const subtitleRef = useRef(null);
  const desktopImageRef = useRef(null);
  const mobileImageRef = useRef(null);
  const desktopTextRef = useRef(null);
  const mobileTextRef = useRef(null);
  const mapRef = useRef(null);

  // Check if elements are in view
  const headerInView = useInView(headerRef, { once: true, amount: 0.3 });
  const titleInView = useInView(titleRef, { once: true, amount: 0.3 });
  const subtitleInView = useInView(subtitleRef, { once: true, amount: 0.3 });
  const desktopImageInView = useInView(desktopImageRef, {
    once: true,
    amount: 0.3,
  });
  const mobileImageInView = useInView(mobileImageRef, {
    once: true,
    amount: 0.3,
  });
  const desktopTextInView = useInView(desktopTextRef, {
    once: true,
    amount: 0.3,
  });
  const mobileTextInView = useInView(mobileTextRef, {
    once: true,
    amount: 0.3,
  });
  const mapInView = useInView(mapRef, { once: true, amount: 0.3 });

  return (
    <div className="pb-28 min-h-screen text-white bg-slate-700">
      <div className=" lg:px-44  px-6  pt-6">
        {/* Header */}

        {/* Main Content - Grid Layout */}
        <div className="grid grid-cols-1 lg:grid-cols-1 ">
          {/* Left Column */}
          <div className="flex flex-col justify-start m">
            <motion.h1
              ref={titleRef}
              className="text-4xl md:text-8xl font-bold text-[#ab052d] mb-2 mt-2 md:mt-12"
              initial={{ opacity: 0, x: -50 }}
              animate={
                titleInView ? { opacity: 1, x: 0 } : { opacity: 0, x: -50 }
              }
              transition={{ globalTransition }}
            >
              Services
            </motion.h1>
            <motion.p
              ref={subtitleRef}
              className="text-xl lg:mb-20"
              initial={{ opacity: 0 }}
              animate={subtitleInView ? { opacity: 1 } : { opacity: 0 }}
              transition={{ globalTransition }}
            >
              <p>
                We serve across Gujarat, India. Our state-of-the-art
                300-square-meter facility is fully dedicated to assembling
                high-quality hydraulic systems. We specialize in servicing
                hydraulic pumps and motors to ensure optimal performance and
                longevity. Additionally, our facility is equipped for rigorous
                testing of hydraulic power units, guaranteeing reliability and
                efficiency for our customers.
              </p>
            </motion.p>
          </div>

          {/* Right Column */}
          <div className="flex flex-col">
            {/* Mission Statement - Desktop */}

            {/* Gujarat Map */}
            <motion.div
              ref={mapRef}
              className="relative hidden lg:block lg:mt-0"
              initial={{ opacity: 0 }}
              animate={mapInView ? { opacity: 1 } : { opacity: 0 }}
              transition={{ globalTransition }}
            ></motion.div>

            {/* Mobile View Image */}
            <motion.div
              ref={mobileImageRef}
              onClick={() => {
                window.open(
                  "https://maps.app.goo.gl/WW3wytLxBza1EUvU6",
                  "_blank"
                );
              }}
              className=" block lg:hidden  cursor-pointer"
              initial={{ scale: 0.8 }}
              animate={
                mobileImageInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }
              }
              transition={{ globalTransition }}
            >
              <Lottie animationData={gujarathMobile} />
            </motion.div>

            {/* Mission Statement - Mobile */}
            <div className="block lg:hidden ">
              <motion.div
                ref={mobileTextRef}
                className="w-[100%] relative h-[40vh]"
                initial={{ opacity: 0, y: 40 }}
                animate={
                  mobileTextInView
                    ? { opacity: 1, y: 0 }
                    : { opacity: 0, y: 40 }
                }
                transition={{ globalTransition }}
              >
                <img
                  src="/assets/image/services.png"
                  alt="Industrial Facility"
                  className="w-full h-full object-cover"
                />
              </motion.div>
            </div>
          </div>
        </div>
      </div>
      {/* Images------ */}

      <div className="w-full min-h-[50vh] hidden  relative lg:flex ">
        <img
          src="/assets/image/services.png"
          alt="Industrial Facility"
          className="top-0 bottom-0 right-[50%] absolute  object-cover "
        />

        <div
          className="absolute -top-24 left-[50%] cursor-pointer px-[10px]"
          onClick={() => {
            window.open("https://maps.app.goo.gl/WW3wytLxBza1EUvU6", "_blank");
          }}
          role="button"
          tabIndex={0}
        >
          <Lottie animationData={gujarathWeb3} />
        </div>
      </div>
    </div>
  );
};

export default ServicesSection;
